import React, { useState, useEffect } from "react";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Person2Icon from "@mui/icons-material/Person2";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import liff from "@line/liff";
import { PostData } from "../services/Request";
import * as Defi from "../services/Define";

const initAttr = {
  userId: "",
  displayName: "",
  pictureUrl: "",
  statusMessage: "",
  idToken: "",
  email: "",

  acc_no: "",
  firstname: "",
  lastname: "",
  tel: "",
  lineid: "",
  pass: "",
  pass_check: "",
  ref_code: "",
  bank: "",
  captcha: "",
  upline: "",
  upline_name: "",
};

const defaultTheme = createTheme();

function RegisterPage() {
  const [attr, setAttr] = useState(initAttr);
  const [log, setLog] = useState("");

  const authen = (item) => {
    setAttr({
      ...attr,
      type: item.type,
      userId: item.userId,
      displayName: item.displayName,
      pictureUrl: item.pictureUrl,
      statusMessage: item.statusMessage,
      idToken: item.idToken,
      email: item.email,
    });

    PostData("authen", "authen", {
      data: {
        type: item.type,
        token: item.idToken,
        userid: item.userId,
        name: item.displayName,
        filepic: item.pictureUrl,
        status: item.statusMessage,
        email: item.email,
      },
    }).then((result) => {
      if (result.status === "OK") {
        liff.closeWindow();
        return;
      }

      setLog(JSON.stringify(result));
    });
  };

  const loginDebug = () => {
    authen({
      userId: Defi.DEBUG_ID,
      displayName: Defi.DEBUG_NAME,
      pictureUrl: Defi.DEBUG_PIC,
      statusMessage: Defi.DEBUG_STATUS,
      idToken: Defi.DEBUG_TOKEN,
      email: Defi.DEBUG_EMAIL,
      type: "LINE",
    });
  };

  const lineLogin = () => {
    liff.init(
      { liffId: Defi.LIFF_ID },
      () => {
        if (liff.isLoggedIn()) {
          const idToken = liff.getIDToken();

          liff
            .getProfile()
            .then((profile) => {
              authen({
                ...profile,
                idToken: idToken,
                email: liff.getDecodedIDToken().email,
                type: "LINE",
              });
            })
            .catch((err) => console.error(err));
        } else {
          liff.login();
        }
      },
      (err) => console.error(err)
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    PostData("authen", "register", {
      firstname: data.get("firstName"),
      lastname: data.get("lastName"),
      email: data.get("email"),
      tel: data.get("tel"),
      idline: data.get("lineId"),
      type: attr.type,
      token: attr.idToken,
      userid: attr.userId,
      name: attr.displayName,
      filepic: attr.pictureUrl,
      status: attr.statusMessage,
      line_email: attr.email,
    }).then((result) => {
      if (result.status === "OK") {
        liff.closeWindow();
        return;
      }

      setLog(JSON.stringify(result));
    });
  };

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      loginDebug();
      return;
    }

    lineLogin();
  }, []);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <Person2Icon />
          </Avatar>
          <Typography component="h1" variant="h5">
            ลงทะเบียนสมาชิก
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="ชื่อ"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  id="lastName"
                  label="นามสกุล"
                  name="lastName"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="E-mail"
                  name="email"
                  autoComplete="email"
                  type="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="tel"
                  label="เบอร์โทรศัพท์"
                  name="tel"
                  autoComplete="tel"
                  type="tel"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="lineId"
                  label="Line ID"
                  name="lineId"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              ลงทะเบียน
            </Button>
          </Box>
        </Box>
        {/* <div>{log}</div> */}
      </Container>
    </ThemeProvider>
  );
}

export default RegisterPage;
